import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offer-verified__operator" }
const _hoisted_2 = ["src", "alt", "title"]

import type { TourOperator } from '@/interfaces/common';

interface Props {
	operator: TourOperator;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OfferVerifiedOperator',
  props: {
    operator: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.operator.Image,
      alt: _ctx.operator.Name,
      title: _ctx.operator.Name,
      class: "offer-verified__operator-logo"
    }, null, 8 /* PROPS */, _hoisted_2)
  ]))
}
}

})